import React, {useState, useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import {Range} from 'react-range';
import priceRangeStore from './price-range-store';

export const PriceRangeSlider: React.FC = observer(() => {
    const {range, min, max, setPriceRange, setMinValue, setMaxValue} = priceRangeStore;
    const [localMin, setLocalMin] = useState(range[0]);
    const [localMax, setLocalMax] = useState(range[1]);
    const announcementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setLocalMin(range[0]);
        setLocalMax(range[1]);

        if (announcementRef.current) {
            announcementRef.current.textContent = range[0] !== min || range[1] !== max ? `Price range: $${range[0]} to $${range[1]}` : '';
        }
    }, [range, min, max]);

    return (
        <div>
            <div
                ref={announcementRef}
                aria-live="polite"
                aria-atomic="true"
                className="sr-only"
            />
            <strong className="d-inline-block">Price Range Filter</strong>
            <div>
                <input
                    type="number"
                    id="min-price"
                    min={min}
                    max={max}
                    value={localMin}
                    onChange={e => setLocalMin(+e.target.value)}
                    onBlur={() => setMinValue(+localMin)}
                    aria-label="Minimum price"
                />
                <span> &minus; </span>
                <input
                    type="number"
                    id="max-price"
                    min={min}
                    max={max}
                    value={localMax}
                    onChange={e => setLocalMax(+e.target.value)}
                    onBlur={() => setMaxValue(+localMax)}
                    aria-label="Maximum price"
                />
            </div>

            <Range
                step={1}
                min={min}
                max={max}
                values={range}
                onChange={setPriceRange}
                renderTrack={({props, children}) => (
                    <div
                        {...props}
                        style={{...props.style}}
                        className="slider"
                    >
                        {children}
                    </div>
                )}
                renderThumb={({props}) => (
                    <div
                        {...props}
                        key={props.key}
                        style={{...props.style}}
                        className="thumb"
                        tabIndex={-1}
                        aria-hidden="true"
                    />
                )}
            />
        </div>
    );
});
